import React, { useMemo } from 'react'

import { CommonReportIcon, CommonBlockIcon, ProfileShareIcon, CommonShareIcon } from '@local/assets/icons'
import { generatePath } from '@local/utils'

import ContextMenu from '@web/components/ContextMenu/ContextMenu'
import SocialPlugin from '@web/components/SocialPlugin'
import useBlockModal from '@web/hooks/useBlockModal'
import { useGoTo } from '@web/hooks/useGoTo'
import useMe from '@web/hooks/useMe'
import usePageInfo, { PageOwner } from '@web/hooks/usePageInfo'
import { IS_BROWSER } from '@web/libs/constants'
import links from '@web/libs/constants/links'
import routes from '@web/libs/constants/routes'

import styles from './ContextMenuTopHome.module.scss'

interface ContextMenuTopHomeType {
  user: NonNullable<PageOwner>
}

const ContextMenuTopHome: React.FC<ContextMenuTopHomeType> = ({ user }) => {
  const { login } = useMe()
  const { pageOwner } = usePageInfo()
  const { goToLogin, goTo } = useGoTo()

  const { openBlockModal, openUnBlockModal } = useBlockModal({ user })

  const shareUrl = useMemo(() => {
    if (!IS_BROWSER) return ''
    return window.location.href
  }, [])

  const onClickBlockUser = () => {
    if (!login) return goToLogin({ showAlert: true })
    return openBlockModal()
  }

  const onClickReportReviewer = () => {
    goTo(links.REPORT_REVIEWER, {
      query: {
        reviewer11: user.profile.nickname,
        reviewid1: links.MY_HOME + generatePath(routes.HOME_REVIEW, { userId: user.id }),
      },
    })
  }

  const items = [
    {
      label: <SocialPlugin url={shareUrl}>공유하기</SocialPlugin>,
      icon: CommonShareIcon,
      visibility: true,
    },
    {
      label: '리뷰어 신고',
      icon: CommonReportIcon,
      clickHandler: onClickReportReviewer,
      visibility: true,
    },
    {
      label: '리뷰어 차단',
      icon: CommonBlockIcon,
      clickHandler: onClickBlockUser,
      visibility: !user.isBlocked,
    },
    {
      label: '차단 해제',
      icon: CommonBlockIcon,
      clickHandler: () => openUnBlockModal(),
      visibility: user.isBlocked,
    },
  ]

  if (pageOwner?.isThemeContentProvider) {
    return (
      <SocialPlugin url={shareUrl} className={styles.btn_manage}>
        <span className="place_blind">공유하기</span>
        <ProfileShareIcon className={styles.icon_share} aria-hidden="true" />
      </SocialPlugin>
    )
  }

  return (
    <ContextMenu
      button={{ alt: '리뷰어 관리', styleClass: styles.btn_manage }}
      layerStyleClass={styles.ly_manage}
      items={items}
    />
  )
}

export default ContextMenuTopHome
